import {AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS} from 'admin-on-rest';
import UserController from './models/user/userController';

export default (actionType, params) => {
  
  if (actionType === AUTH_LOGOUT) {
    UserController._removeLoggedInUserFromLocalStorage();
    return Promise.resolve();
  }
  
  if (actionType === AUTH_ERROR) {
    
    const status = params.message.status;
    
    if (status === 401 || status === 403) {
      UserController._removeLoggedInUserFromLocalStorage();
      return Promise.reject();
    }
    return Promise.resolve();
  }
  
  if (actionType === AUTH_CHECK) {
    
    const userId = UserController._getLoggedInUserId();
    
    if (!userId)
      return Promise.reject('Unkown method');
  }
  
  if(actionType === AUTH_GET_PERMISSIONS) {

    const role = UserController._getLoggedInUserRole();
    
    if(role) {
      return Promise.resolve(role.title);
    }
    return Promise.reject();
  }

};


// WEBPACK FOOTER //
// ./src/AuthClient.js